// Export IntakeToTriage component
import IntakeToTriage from "./IntakeToTriage";
export default IntakeToTriage;
